





























































































import { Component, Vue } from 'vue-property-decorator';
import RecTextField from '@/components/global/input/RecTextField.vue';
import { auth } from '@/plugins/papybase/papybaseInit';
import { MUTATE_AUTH } from '@/store/modules/auth';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import { AuthErrorCode, Error } from '@luxtag/papybase';

@Component({
    components: {
        RecTextField,
        SimpleDialog,
    },
    $_veeValidate: { validator: 'new' },
})
export default class ResetPasswordForm extends Vue {
    public showProgress= false;

    public showSimpleDialog = false;

    // state of where reset password email has been sent or not
    public formState = true;

    public showPassword = false;
    public showPasswordConfirmation = false;

    public form = {
        password: '',
        passwordConfirmation: '',
    }

    public dictionary = {
        en: {
            attributes: {
                passwordConfirmation: 'password',
            },
        },
    };

    public async passwordReset() {
        // prevent for sign in to work while progress is show up
        if (this.showProgress) return;

        const valid = await this.$validator.validateAll();
        if (valid) {
            this.showProgress = true;
            auth.resetPassword(this.code, this.form.password, this.form.passwordConfirmation)
                .then((res:any) => {
                    this.formState = false;
                }).catch((err: any) => {
                    console.error(err);
                    if (err.code === 'invalid-code') {
                        this.showSimpleDialog = true;
                    }
                }).finally(() => {
                    this.showProgress = false;
                });
        }
    }

    public mounted() {
        this.$validator.localize(this.dictionary);
    }

    get code(): string {
        if (this.$route.query.code) {
            return (this.$route.query.code as string);
        }
        return '';
    }
}
